const flatten = require('flat');

function hasCategory(categories, categoryDefinition) {
  const categoriesToMatch = Object.values(flatten(categoryDefinition));
  categoriesToMatch.sort((a, b) => b.length - a.length);

  return categoriesToMatch.find(category => categories?.find(c => c.title?.indexOf(category) === 0));

  // let res = categories?.find((cat) => {
  //   if (!cat) {
  //     return false;
  //   }
  //   if (categoryDefinition instanceof Array) {
  //     return categoryDefinition.find((c) => hasCategory([cat], c));
  //   }
  //   if (typeof categoryDefinition === 'object') {
  //     return Object.values(categoryDefinition).find((c) => hasCategory([cat], c));
  //   }
  //   return matcher(categoryDefinition, cat);
  // });

  // if (!res && matcher === defaultMatcher) {
  //   if (hasCategory(categories, categoryDefinition, (def, cat) => cat.title?.indexOf(def) === 0)) {
  //     res = categoryDefinition;
  //   }
  // }

  // return res;
}

module.exports = {
  hasCategory,
};
